import * as React from "react";
import * as cn from "classnames";

import styles = require("./style.less");

interface DataTableRowProps {
    displayNoBorder?: boolean;
}

export class DataTableRow extends React.Component<any, any> {
    render() {
        const {
            displayNoBorder,
            className,
            ...otherProps
        } = this.props;

        return (
            <tr {...otherProps} className={cn(className, styles.dataTableRow, displayNoBorder ? styles.noBorder : "")} >
                {this.props.children}
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DataTable/DataTableRow.tsx